import type { PlatformComponentProps } from "@b2bportal/core-types";
import { DeparturePage } from "@tenant/flights";
import {
  CoreFlightExchangeSteps,
  FlightsExchangeNavigationFlow,
} from "../../navigationFlow";
import { useExchangeDeparturePage } from "./hooks";
import { useExchangeDeparturePageRoute } from "./hooks/useExchangeDeparturePageRoute";

export const ExchangeDeparturePageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useExchangeDeparturePageRoute();
  const goToNextStep = FlightsExchangeNavigationFlow.useGoToNextStep(
    CoreFlightExchangeSteps.DEPARTURE
  );
  const data = useExchangeDeparturePage({ ...params, goToNextStep });
  return (
    <DeparturePage className={className} {...data}>
      {children}
    </DeparturePage>
  );
};
